module.exports = __webpack_public_path__ + "static/media/google-maps.eeea250b.png";